module.exports = __webpack_public_path__ + "static/media/login-3.2f096fb9.png";